<template>
  <div>
    <dialog-show-invoice-bills
      :bills="bills"
      @close="toggleBills([])"
    />
    <v-list
        class="py-0"
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-subheader>
        <b>Счета</b>
      </v-subheader>

      <v-skeleton-loader
          v-if="loading"
          type="list-item-avatar-two-line"
      />

      <div v-else>
        <div v-for="(invoice, index) in buyoutItem.invoices"
             :key="invoice.id"
        >
          <InvoiceListItem
              :buyout="buyout"
              :buyout-item="buyoutItem"
              :ccy="ccy"
              :idx="index + 1"
              :invoice="invoice"
              :sourceStatuses="sourceStatuses"
              @show-bills="toggleBills"
          />
          <v-divider v-if="index + 1 < buyoutItem.invoices.length"/>
        </div>
      </div>
    </v-list>
  </div>
</template>

<script>
import DialogShowInvoiceBills from '@/components/DialogShowInvoiceBills'
import InvoiceListItem from '@/components/InvoiceListItem'

export default {
  name: 'InvoiceList',
  components: {DialogShowInvoiceBills, InvoiceListItem},
  data () {
    return {
      bills: []
    }
  },
  methods: {
    toggleBills (bills) {
      this.bills = bills
    }
  },
  props: {
    buyout: {
      type: Object
    },
    buyoutItem: {
      type: Object
    },
    ccy: {
      type: String
    },
    loading: {
      required: true,
      type: Boolean
    },
    sourceStatuses: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>